export const TRANSLATIONS = {
  WIDGET_TITLE: 'Your exchange rates',
  LOADING_OPTIONS: 'Loading exchange rate options',
  ERROR_LOADING: 'Error loading FX Rates',
  ERROR_MISSING_OPTIONS: '<FXRateCalculator /> Missing FX Rate options',
  ERROR_NO_UNIQUE:
    '<FXRateCalculator /> Unable to set unique options for FX Widget'
};

export const MAX_AMOUNT_VALUE = 10000000000000;

export const FX_TEST_ID_PAY_CURRENCY = 'fx-pay-currency';
export const FX_TEST_ID_BUY_CURRENCY = 'fx-buy-currency';
export const FX_RESET_BUTTON = 'fx-reset-button';
export const FX_CALCULATED_AMOUNT = 'fx-calculated-amount';
export const FX_AMOUNT_TEST_ID = 'fx-amount';
